import { render, staticRenderFns } from "./H5NewsImageConfig.vue?vue&type=template&id=3e45697e"
import script from "./H5NewsImageConfig.vue?vue&type=script&lang=js"
export * from "./H5NewsImageConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports